var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22229",
    transform: "translate(-3014.5 -5354)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/Container/56x56",
    transform: "translate(3014.5 5354)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/external/link/black",
    transform: "translate(3033.5 5368.263)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/external/link"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4",
    transform: "translate(0 0.612)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 1",
    d: "M17,8.4v7.2a2.474,2.474,0,0,1-.664,1.7,2.205,2.205,0,0,1-1.6.7H2.266A2.336,2.336,0,0,1,0,15.6V2.4A2.336,2.336,0,0,1,2.266,0h6.8",
    transform: "translate(0 5.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 2",
    d: "M0,0H7V8",
    transform: "translate(14 0.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M0,14,13,0",
    transform: "translate(8 0.125)",
    fill: "none",
    stroke: "#233588",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.db31ab92cd15e50e2a47108eb845457b.svg";
export { ForwardRef as ReactComponent };